import { SET_WORK_ITEMS, SET_WORK_ITEMS_ARE_LOADED } from '@/store/mutation-types'
import { getAvailableWorkItemTypes } from '@/utils/azure-devops-helpers/work-item'
import { handleError } from '@/utils/error-handling'
import { OBJECTIVE_TYPES } from '@/utils/objective-types'
import { uid } from '@/utils/uid'

const state = {
  workItems: [],
  workItemsAreLoaded: false
}

const mutations = {
  [SET_WORK_ITEMS](state, value) {
    state.workItems = value
  },

  [SET_WORK_ITEMS_ARE_LOADED](state) {
    state.workItemsAreLoaded = true
  }
}

const actions = {
  async loadWorkItems({ commit }) {
    try {
      const availableWorkItemTypes = await getAvailableWorkItemTypes()

      const normalizedWorkItems = availableWorkItemTypes.map(workItemType => {
        return {
          ...workItemType,
          typeId: OBJECTIVE_TYPES.WORK_ITEM,
          issueIcon: workItemType.icon?.url || null,
          id: workItemType.id || uid()
        }
      })

      commit(SET_WORK_ITEMS, normalizedWorkItems)
    } catch (error) {
      handleError({ error })
    } finally {
      commit(SET_WORK_ITEMS_ARE_LOADED)
    }
  }
}

const getters = {
  workItemsColorsMap: state => {
    return state.workItems.reduce((acc, workItem) => {
      const { color, name } = workItem
      acc[name] = color
      return acc
    }, {})
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
